
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"id-25a"}},[_c('path',{attrs:{"d":"M26 16c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm3.971-14.835A1 1 0 0130.2 2.75L25.58 7.37v2.048h2.048l4.62-4.618a1 1 0 011.52.123l.065.104a9.514 9.514 0 01-1.272 10.925 11.87 11.87 0 00-1.829-.983 7.517 7.517 0 001.914-7.657l-.021-.061-3.875 3.874a1 1 0 01-.575.284l-.132.01h-3.462a1 1 0 01-1-1V6.954a1 1 0 01.293-.707l3.872-3.875-.06-.02a7.52 7.52 0 00-9.35 9.718 1 1 0 01-.234 1.046L2.784 28.43a2.677 2.677 0 003.786 3.786l7.498-7.502a12.136 12.136 0 00.027 2.802L7.984 33.63a4.677 4.677 0 01-4.286 1.266l-.232-.055a4.677 4.677 0 01-2.096-7.825l14.885-14.882-.067-.25a9.52 9.52 0 012.799-9.392l.227-.2a9.518 9.518 0 0110.757-1.127zM26 18a8 8 0 100 16 8 8 0 000-16zm0 11a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm.78-8.923A4 4 0 0126 28a1 1 0 01-.117-1.993L26 26a2 2 0 10-1.993-2.169L24 24a1 1 0 01-2 0 4 4 0 014.78-3.923z"}})])]),_c('g',{attrs:{"clip-path":"url(#id-25a)","transform":"translate(5 5)"}},[_c('path',{attrs:{"fill":"#10171D","d":"M0 0h36v36H0V0z"}})])])
          )
        }
      }
    